/**
 * defined unique navigation component names
 * used for queryParams in internal navigation
 */
export var NavigationComponent;
(function (NavigationComponent) {
  NavigationComponent["ORGA_ADMIN"] = "orga-list";
  NavigationComponent["ORGA_DETAIL"] = "orga-detail";
  NavigationComponent["ORGA_CREATE"] = "create-orga";
  NavigationComponent["USER_ADMIN"] = "user-list";
  NavigationComponent["USER_DETAIL"] = "user-detail";
  NavigationComponent["USER_CREATE"] = "user-create";
  NavigationComponent["PROFILE"] = "profile";
  NavigationComponent["NOTIFICATIONS"] = "notification-settings";
  NavigationComponent["WIZARD"] = "wizard-step";
})(NavigationComponent || (NavigationComponent = {}));
